const API_BASE_URL = String(import.meta.env.VITE_API_BASE_URL || "").replace(/\/$/, "");

export class ApiError extends Error {
  constructor(message, { status = 0, code = null, details = null, requestId = null } = {}) {
    super(message || "API request failed");
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.details = details;
    this.requestId = requestId;
  }
}

function buildUrl(path) {
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

export async function apiRequest(path, { method = "GET", body, headers = {}, signal, skipAuthBootstrap = false } = {}) {
  const response = await authenticatedFetch(buildUrl(path), {
    method,
    credentials: "include",
    signal,
    skipAuthBootstrap,
    headers: {
      Accept: "application/json",
      ...(body === undefined || body instanceof FormData
        ? {}
        : { "Content-Type": "application/json" }),
      ...headers
    },
    body: body === undefined
      ? undefined
      : (body instanceof FormData ? body : JSON.stringify(body))
  });

  let payload = null;
  const contentType = response.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    payload = await response.json();
  } else {
    const text = await response.text();
    payload = text ? { success: response.ok, message: text } : null;
  }

  const requestId = payload?.meta?.request_id || response.headers.get("x-request-id") || null;

  if (!response.ok || payload?.success === false) {
    throw new ApiError(payload?.message || `HTTP ${response.status}`, {
      status: response.status,
      code: payload?.code ?? null,
      details: payload?.details ?? null,
      requestId
    });
  }

  return payload;
}

export function apiData(payload) {
  return payload?.data ?? payload;
}

import { clearTikTokSessionMarker, createTikTokSession } from "@/services/tiktokAuth.js";
const nativeFetch=globalThis.fetch.bind(globalThis); let bootstrap=null;
function pathOf(input){const raw=typeof input==="string"?input:String(input?.url||input||"");try{return new URL(raw,location?.href||"https://local.invalid/").pathname}catch{return raw.split("?")[0].split("#")[0]}}
function authEndpoint(input){return ["/api/auth/tiktok/login","/api/auth/tiktok/mock-login","/api/auth/logout"].includes(pathOf(input));}
async function rawApiRequest(path,{method="GET",body,headers={}}={}){
 const r=await nativeFetch(buildUrl(path),{method,credentials:"include",headers:{Accept:"application/json",...(body===undefined?{}:{"Content-Type":"application/json"}),...headers},body:body===undefined?undefined:JSON.stringify(body)});
 const ct=r.headers.get("content-type")||""; const p=ct.includes("application/json")?await r.json():{success:r.ok,message:await r.text()};
 if(!r.ok||p?.success===false) throw new ApiError(p?.message||`HTTP ${r.status}`,{status:r.status,code:p?.code??null,details:p?.details??null,requestId:p?.meta?.request_id||null}); return p;
}
async function ensureSession({force=false}={}){if(bootstrap)return bootstrap;bootstrap=createTikTokSession(rawApiRequest,{force});try{return await bootstrap}finally{bootstrap=null}}
async function authenticatedFetch(input,init={}){
 const skip=Boolean(init.skipAuthBootstrap)||authEndpoint(input); const clean={...init}; delete clean.skipAuthBootstrap;
 if(!skip&&pathOf(input).startsWith("/api/")) await ensureSession();
 let r=await nativeFetch(input,clean);
 if(!skip&&r.status===401&&pathOf(input).startsWith("/api/")){clearTikTokSessionMarker();await ensureSession({force:true});r=await nativeFetch(input,clean)}
 return r;
}
